import { render } from "./Index.vue?vue&type=template&id=51d78df9&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-51d78df9"

export default script